import { api } from '@api/services/axios';
import { useMutation, useQuery } from 'react-query';

export const optiMutation = (url, method, callBack, cacheTime) => {
  return useMutation(
    async payload => {
      const { data, status } = await api[method](url, payload ?? {});
      return { data, status };
    },
    {
      retry: false,
      retryOnMount: false,

      cacheTime: cacheTime ?? 60000,
      staleTime: 30000,

      refetchOnWindowFocus: false, // Não refetch ao focar janela
      refetchOnReconnect: true, // Refetch ao reconectar internet

      onSuccess: data => {
        if (callBack) callBack(data);
      },
    }
  );
};

export const optiQuery = (url, method, params, cacheTime, condicaoFetch) => {
  return useQuery(
    url,
    async () => {
      const { data, status } = await api[method](url, params);
      return { data, status };
    },
    {
      retry: false,
      retryOnMount: false,

      refetchOnMount: false, // Não refetch ao montar o componente
      refetchOnWindowFocus: false, // Não refetch ao focar janela
      refetchOnReconnect: true, // Refetch ao reconectar internet

      cacheTime: cacheTime ?? 60000,
      staleTime: 30000,

      enabled: Boolean(condicaoFetch),
      keepPreviousData: true, // Mantém dados anteriores durante refetch
    }
  );
};
